import React from 'react'
import { Layout, Breadcrumb, Space } from 'antd'
import { HomeOutlined, RightOutlined } from '@ant-design/icons'
import './PageLayout.css'

const { Content } = Layout

interface PageLayoutProps {
    title: string
    children: React.ReactNode
    breadcrumb?: { title: string; path?: string }[]
    embedded?: boolean
    framed?: boolean
}

const PageLayout: React.FC<PageLayoutProps> = ({
    children,
    breadcrumb = [],
    embedded = false,
    framed = false,
}) => {
    if (embedded) {
        return <>{children}</>
    }

    const content = (
        <Space direction="vertical" style={{ width: '100%' }} size="large">
            {breadcrumb.length > 0 && (
                <Breadcrumb
                    className="page-breadcrumb"
                    separator={
                        <RightOutlined className="page-breadcrumb-separator" />
                    }
                    items={[
                        {
                            title: <HomeOutlined />,
                            href: '/',
                        },
                        ...breadcrumb.map((item) => ({
                            title: item.title,
                            href: item.path,
                        })),
                    ]}
                />
            )}

            <Content className="site-content">{children}</Content>
        </Space>
    )

    return (
        <div
            className={
                framed ? 'page-container page-container-framed' : 'page-container'
            }
        >
            {framed ? <div className="page-layout-frame">{content}</div> : content}
        </div>
    )
}

export default PageLayout
